import { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { ReactComponent as CloseStrokeSVG } from 'icons/close-stroke.svg';
import { format } from 'date-fns';

import { useOutsideClick } from 'helpers/clickOutside';
import { STAGES } from 'config/teleconsultation';

const TeleconsultationModal = ({ event, onClose, onClickOutside }) => {
  const modalRef = useRef(null);
  const history = useHistory();

  useOutsideClick(modalRef, onClickOutside);

  return (
    <div
      className="fullscreen-modal-container"
      style={{ visibility: 'visible' }}
    >
      <div className="fullscreen-modal-background"></div>
      <div
        ref={modalRef}
        className="fullscreen-modal fullscreen-modal-action fullscreen-modal-wide"
      >
        <section className="modal-content">
          <header className="modal-header">
            <h1>{event.title}</h1>
          </header>
          <span onClick={onClose} className="pointer close">
            <CloseStrokeSVG />
          </span>

          <div className="modal-body">
            <p>
              <b>Stage:</b> {STAGES.find((s) => event.stage === s.id).label}
              <br />
              <b>Start time:</b> {format(event.start, 'MMM d, H:mm')}
              <br />
              <b>End time:</b> {format(event.end, 'MMM d, H:mm')}
            </p>
          </div>
          <span className="apps-grid-title">Patient</span>
          <div className="apps-grid">
            <div className="apps-grid-cell pointer">
              <article
                className="apps-card-app"
                onClick={() => history.push(`/customers/${event.customer.id}`)}
              >
                <div className="apps-card-left">
                  <div className="apps-card-meta">
                    <h3 className="apps-card-app-title">
                      {event.customer.firstName} {event.customer.lastName}
                    </h3>
                    <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                      {event.customer.email}
                    </p>
                    <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                      {event.customer.phone}
                    </p>
                    <p className="ma0 pa0 middarkgrey f8 th-members-list-email">
                      {event.customer.city} - {event.customer.address}
                    </p>
                  </div>
                </div>
              </article>
            </div>
          </div>
          <div className="modal-footer flex justify-end">
            <button
              data-cy="submit"
              className="btn-green"
              onClick={() => history.push(`/teleconsultations/${event.id}`)}
            >
              <span>Go to teleconsultation</span>
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TeleconsultationModal;
